<div class="container-fluid admin-container mb-5 ">
    <div>
        <div class="col-md-12">
            <div class="page-header">
                <div>
                    <p class="page-title">{{deviceTitle}}</p>
                </div>
            </div>
        </div>
        <form content [formGroup]="deviceForm" (ngSubmit)="addNewDevice()" id="deviceForm" class="row">
            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label-required" for="name"><span class="required">*
                        </span>{{resourceKeyValue.deviceType}}</label>
                    <div class="input-group">
                        <select class="custom-select select-field" id="deviceType" formControlName="deviceType"
                            [(ngModel)]='selectedDeviceTypeValue' (change)="selectDeviceType($event.target.value)"
                            [class.is-invalid]="deviceForm.controls.deviceType.invalid && deviceForm.controls.deviceType.dirty">
                            <option class="select-option" [value]="0" disabled>
                                {{resourceKeyValue.hintSelectDevieType}}
                            </option>
                            <option class="select-option" *ngFor="let deviceType of allDeviceTypes"
                                [value]="deviceType.name">
                                {{deviceType.name}}</option>
                        </select>
                        <div class="invalid-feedback"
                            *ngIf="deviceForm.controls.deviceType.invalid && deviceForm.controls.deviceType.dirty"
                            id="deviceType-validation">
                            <small
                                *ngIf="deviceForm.controls.deviceType.errors.required">{{resourceKeyValue.validationDeviceTypeRequired}}</small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label class="control-label-required" for="name"><span class="required">*
                        </span>{{resourceKeyValue.deviceId}}</label>
                    <input type="text" class="form-control" id="deviceId"
                        placeholder="{{resourceKeyValue.serialNoPattern}}" formControlName="deviceId"
                        [class.is-invalid]="deviceForm.controls.deviceId.invalid && deviceForm.controls.deviceId.dirty">
                    <div class="invalid-feedback"
                        *ngIf="deviceForm.controls.deviceId.invalid && deviceForm.controls.deviceId.dirty"
                        id="deviceId-validation">
                        <small
                            *ngIf="deviceForm.controls.deviceId.errors?.onlyWhiteSpace">{{resourceKeyValue.onlyWhiteSpaceNotAllowed}}</small>
                        <small
                            *ngIf="deviceForm.controls.deviceId.errors.errorDeviceID">{{resourceKeyValue.validationDeviceIDAlreadyExist}}</small>
                        <small
                            *ngIf="deviceForm.controls.deviceId.errors.errorDeviceModel">{{resourceKeyValue.validateDeviceFormat}}</small>
                        <small
                            *ngIf="deviceForm.controls.deviceId.errors.required">{{resourceKeyValue.validationDeviceRequired}}</small>
                        <small
                            *ngIf="deviceForm.controls.deviceId.errors.maxlength">{{resourceKeyValue.validationLengthMustbe200Characters}}</small>
                    </div>
                </div>
            </div>
            <div class="form-group invisible-collapsed" [hidden]="true">
                <label for="id">ID</label>
                <input type="text" disabled=true class="form-control" id="id" placeholder="ID" formControlName="id"
                    value="0">
            </div>
        </form>
    </div>
    <div class="form-button-fixed">
        <button id="cancelDeviceBtn" class="btn btn-secondary" [routerLink]="['/devices']">
            {{resourceKeyValue.cancel}}
        </button>
        <button id="createDeviceBtn" type="submit" class="btn btn-primary ml-3" form="deviceForm"
            [disabled]="isLoading || !deviceForm.valid || (deviceForm.valid && deviceForm.pristine) || selectedDeviceTypeId === 0">
            {{resourceKeyValue.save}}
        </button>
    </div>
</div>
<!--Device creation modal-->
<ng-template #deviceCreationModal let-modal>
    <div class="modal-header">
        <h3 class="modal-title" id="deviceCreationPopup">{{resourceKeyValue.clinicianDeviceCreationPopup}}</h3>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12">
                <p>{{resourceKeyValue.differentFacilityCreateDevice}}</p>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" tabindex="-1" class="btn btn-secondary"
            (click)="closeCreateDevice();">{{resourceKeyValue.cancel}}</button>
        <button type="button" class="btn btn-primary ml-4"
            (click)="createDeviceWorkflow();">{{resourceKeyValue.ok}}</button>
    </div>
</ng-template>
<app-loader [isLoading]=isLoading></app-loader>